import {Box} from "@mui/material";
import {useIsMobileContext} from "@nitra/nkmb-card-components";
import {useEffect, useState} from "react";
import {Lightbox, Slide} from "yet-another-react-lightbox";
import {Inline} from "yet-another-react-lightbox/plugins";
import "yet-another-react-lightbox/styles.css";

function imageLink(asset: string, isMobile: boolean) {
	if (isMobile) {
		return `/2025-about-brochure/1080x1920/${asset}`;
	} else {
		return `/2025-about-brochure/1240x874/${asset}`;
	}

}

export default function Brochure() {

	const [open, setOpen] = useState(false);
	const [index, setIndex] = useState(0);
	const isMobile = useIsMobileContext()

	const toggleOpen = (state: boolean) => () => setOpen(state);
	const [slides, setSlides] = useState<Slide[]>([]);

	useEffect(() => {
		const slideNames = isMobile ? [
			{asset: "NK MARIBOR_Predstavitev kluba za evropske pokale_Brosura_1080x1920.jpg",},
			{asset: "NK MARIBOR_Predstavitev kluba za evropske pokale_Brosura_1080x19202.jpg",},
			{asset: "NK MARIBOR_Predstavitev kluba za evropske pokale_Brosura_1080x19203.jpg",},
			{asset: "NK MARIBOR_Predstavitev kluba za evropske pokale_Brosura_1080x19204.jpg",},
			{asset: "NK MARIBOR_Predstavitev kluba za evropske pokale_Brosura_1080x19205.jpg",},
			{asset: "NK MARIBOR_Predstavitev kluba za evropske pokale_Brosura_1080x19206.jpg",},
			{asset: "NK MARIBOR_Predstavitev kluba za evropske pokale_Brosura_1080x19207.jpg",},
			{asset: "NK MARIBOR_Predstavitev kluba za evropske pokale_Brosura_1080x19208.jpg",},
			{asset: "NK MARIBOR_Predstavitev kluba za evropske pokale_Brosura_1080x19209.jpg",},
			{asset: "NK MARIBOR_Predstavitev kluba za evropske pokale_Brosura_1080x192010.jpg",},
			{asset: "NK MARIBOR_Predstavitev kluba za evropske pokale_Brosura_1080x192011.jpg",},
			{asset: "NK MARIBOR_Predstavitev kluba za evropske pokale_Brosura_1080x192012.jpg",},
			{asset: "NK MARIBOR_Predstavitev kluba za evropske pokale_Brosura_1080x192013.jpg",},
			{asset: "NK MARIBOR_Predstavitev kluba za evropske pokale_Brosura_1080x192014.jpg",},
			{asset: "NK MARIBOR_Predstavitev kluba za evropske pokale_Brosura_1080x192015.jpg",},
			{asset: "NK MARIBOR_Predstavitev kluba za evropske pokale_Brosura_1080x192016.jpg",},
			{asset: "NK MARIBOR_Predstavitev kluba za evropske pokale_Brosura_1080x192017.jpg",},
			{asset: "NK MARIBOR_Predstavitev kluba za evropske pokale_Brosura_1080x192018.jpg",},

		] : [
			{asset: "NK MARIBOR_Predstavitev kluba za evropske pokale_Brosura_WEB_Lezece.jpg",},
			{asset: "NK MARIBOR_Predstavitev kluba za evropske pokale_Brosura_WEB_Lezece2.jpg",},
			{asset: "NK MARIBOR_Predstavitev kluba za evropske pokale_Brosura_WEB_Lezece3.jpg",},
			{asset: "NK MARIBOR_Predstavitev kluba za evropske pokale_Brosura_WEB_Lezece4.jpg",},
			{asset: "NK MARIBOR_Predstavitev kluba za evropske pokale_Brosura_WEB_Lezece5.jpg",},
			{asset: "NK MARIBOR_Predstavitev kluba za evropske pokale_Brosura_WEB_Lezece6.jpg",},
			{asset: "NK MARIBOR_Predstavitev kluba za evropske pokale_Brosura_WEB_Lezece7.jpg",},
			{asset: "NK MARIBOR_Predstavitev kluba za evropske pokale_Brosura_WEB_Lezece8.jpg",},
			{asset: "NK MARIBOR_Predstavitev kluba za evropske pokale_Brosura_WEB_Lezece9.jpg",},
			{asset: "NK MARIBOR_Predstavitev kluba za evropske pokale_Brosura_WEB_Lezece10.jpg",},
			{asset: "NK MARIBOR_Predstavitev kluba za evropske pokale_Brosura_WEB_Lezece11.jpg",},
			{asset: "NK MARIBOR_Predstavitev kluba za evropske pokale_Brosura_WEB_Lezece12.jpg",},
			{asset: "NK MARIBOR_Predstavitev kluba za evropske pokale_Brosura_WEB_Lezece13.jpg",},
			{asset: "NK MARIBOR_Predstavitev kluba za evropske pokale_Brosura_WEB_Lezece14.jpg",},
			{asset: "NK MARIBOR_Predstavitev kluba za evropske pokale_Brosura_WEB_Lezece15.jpg",},
			{asset: "NK MARIBOR_Predstavitev kluba za evropske pokale_Brosura_WEB_Lezece16.jpg",},
		]

		const newSlides = slideNames.map(({asset, ...rest}) => {
			const width = isMobile ? 1080 : 1240;
			const height = isMobile ? 1920 : 874;

			return {
				src: imageLink(asset, isMobile),
				width,
				height,
				srcSet: [{
					src: imageLink(asset, isMobile),
					width: width,
					height: height,
				}],
				...rest,
			};

		})
		setSlides(newSlides);
	}, [isMobile])


	const updateIndex =
		(when: boolean) =>
			({index: current}: { index: number }) => {
				if (when === open) {
					setIndex(current);
				}
			};

	return (
		<Box
			sx={{
				marginInline: "-16px"
			}}
		>
			<Lightbox
				index={index}
				slides={slides}
				plugins={[Inline]}
				on={{
					view: updateIndex(false),
					click: toggleOpen(true),
				}}
				carousel={{
					padding: 0,
					spacing: 0,
					imageFit: "cover",
				}}
				inline={{
					style: {
						width: "100%",
						maxWidth: isMobile ? "900px" : "1240px",
						aspectRatio: isMobile ? "1080/1920" : "1240/874",
						margin: "0 auto",
						// paddingTop: "060px"
					},
				}}
			/>

			<Lightbox
				open={open}
				close={toggleOpen(false)}
				index={index}
				slides={slides}
				on={{view: updateIndex(true)}}
				animation={{fade: 0}}
				controller={{closeOnPullDown: true, closeOnBackdropClick: true}}
			/>

		</Box>
	);
}